// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: #2c3e50;
  color: white;
  padding: 4rem 0 2rem;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.footer-content {
  display: grid;
  grid-template-columns: 1.5fr 2fr;
  gap: 4rem;
  margin-bottom: 3rem;
}

.footer-info {
  animation: fadeIn 0.8s ease-out;
}

.footer-name {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  background: linear-gradient(45deg, #3498db, #2ecc71);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.footer-description {
  color: #bdc3c7;
  line-height: 1.6;
  margin-bottom: 2rem;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.footer-section h4 {
  color: #3498db;
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
}

.footer-section nav {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.footer-section a {
  color: #bdc3c7;
  text-decoration: none;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.footer-section a:hover {
  color: #3498db;
  transform: translateX(5px);
}

.footer-social {
  display: flex;
  gap: 1rem;
}

.footer-social a {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(52, 152, 219, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.footer-social a:hover {
  background: #3498db;
  transform: translateY(-3px);
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #bdc3c7;
}

.footer-drone a {
  color: #3498db;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
}

.footer-drone a:hover {
  color: #2ecc71;
}

.footer-drone a::before {
  content: '🚁';
  font-size: 1.2rem;
}

@media (max-width: 968px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .footer-links {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .footer-links {
    grid-template-columns: 1fr;
  }

  .footer-bottom {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".footer {\n  background: #2c3e50;\n  color: white;\n  padding: 4rem 0 2rem;\n}\n\n.footer-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: 1.5fr 2fr;\n  gap: 4rem;\n  margin-bottom: 3rem;\n}\n\n.footer-info {\n  animation: fadeIn 0.8s ease-out;\n}\n\n.footer-name {\n  font-size: 1.8rem;\n  margin-bottom: 1rem;\n  background: linear-gradient(45deg, #3498db, #2ecc71);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.footer-description {\n  color: #bdc3c7;\n  line-height: 1.6;\n  margin-bottom: 2rem;\n}\n\n.footer-links {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n}\n\n.footer-section h4 {\n  color: #3498db;\n  margin-bottom: 1.5rem;\n  font-size: 1.2rem;\n}\n\n.footer-section nav {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n\n.footer-section a {\n  color: #bdc3c7;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.footer-section a:hover {\n  color: #3498db;\n  transform: translateX(5px);\n}\n\n.footer-social {\n  display: flex;\n  gap: 1rem;\n}\n\n.footer-social a {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(52, 152, 219, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.footer-social a:hover {\n  background: #3498db;\n  transform: translateY(-3px);\n}\n\n.footer-bottom {\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  padding-top: 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #bdc3c7;\n}\n\n.footer-drone a {\n  color: #3498db;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.footer-drone a:hover {\n  color: #2ecc71;\n}\n\n.footer-drone a::before {\n  content: '🚁';\n  font-size: 1.2rem;\n}\n\n@media (max-width: 968px) {\n  .footer-content {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n  }\n\n  .footer-links {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 576px) {\n  .footer-links {\n    grid-template-columns: 1fr;\n  }\n\n  .footer-bottom {\n    flex-direction: column;\n    text-align: center;\n    gap: 1rem;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
